import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@services/layout/theme.service';
import { LoadingService } from '@services/shared/loading.service';
import { LoadingComponent } from '@shared/components/loading/loading.component';
import { SharedModule } from '@shared/modules/shared.module';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	standalone: true,
	imports: [RouterOutlet, SharedModule, LoadingComponent, ConfirmDialog],
})
export class AppComponent implements OnInit {
	currentTheme: 'light' | 'dark' = 'light';

	constructor(
		public loadingService: LoadingService,
		private themeService: ThemeService,
	) {}

	ngOnInit() {
		this.themeService.theme$.subscribe((theme) => {
			this.currentTheme = theme;
		});

		this.themeService.setTheme(this.currentTheme);
	}

	switchTheme() {
		const newTheme = this.currentTheme === 'light' ? 'dark' : 'light';
		this.themeService.setTheme(newTheme);
	}
}
